import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'lkd-notfound',
  templateUrl: './notfound.component.html',
  styles: []
})
export class NotfoundComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
